import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import FormInput from '../../../../commonComponents/forms/FormInput';
import DateRange from '../../../../commonComponents/forms/inputs/DateRange';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import translate from '../../../../commonComponents/translate';
import { getStartDateAndEndDateInterval } from '../../../../services/dateUtilityFunctions';
import ConfigsContext from '../../../../contextProviders/ConfigsContext';

function CareerFilters(props) {
  const { loggedUser } = useContext(LoggedUserContext);
  const { _id: loggedUserId } = loggedUser;
  const { t, filters, onFilterChange, onDateChange = [] } = props;
  const { user, startDate, endDate } = filters;
  const { organization } = useContext(ConfigsContext);
  const { directSelling } = organization;

  const inputProps = useCallback(
    field => {
      switch (field) {
        case 'user':
          return {
            allowClear: true,
            url: '/user/table/network/list',
            filterUrl: '/user/table/network/list',
          };
        default:
          return {
            items: [],
          };
      }
    },
    [loggedUserId],
  );

  const dateRanges = {
    [t('dateRange_thisWeek')]: getStartDateAndEndDateInterval(
      directSelling,
      null,
    ),
    [t('dateRange_lastWeek')]: getStartDateAndEndDateInterval(
      directSelling,
      moment().subtract(1, 'weeks'),
    ),
    [t('dateRange_twoWeeksAgo')]: getStartDateAndEndDateInterval(
      directSelling,
      moment().subtract(2, 'weeks'),
    ),
    [t('dateRange_threeWeeksAgo')]: getStartDateAndEndDateInterval(
      directSelling,
      moment().subtract(3, 'weeks'),
    ),
    [t('dateRange_fourWeeksAgo')]: getStartDateAndEndDateInterval(
      directSelling,
      moment().subtract(4, 'weeks'),
    ),
  };

  return (
    <div className="filters-wrapper">
      <div className="career-filter-container">
        <FormInput
          id="user"
          value={user}
          name="user"
          disabled={false}
          placeholder={t('user')}
          type="users"
          onChange={onFilterChange('user')}
          inputProps={inputProps('user')}
        />
      </div>
      <div className="career-filter-container">
        <DateRange
          id="dateRange"
          placeholder={t('report.arcova.searchDate')}
          startDate={startDate}
          endDate={endDate}
          onChange={({ startDate: sDate, endDate: eDate }) =>
            onDateChange(sDate, eDate)
          }
          onClear={() => onDateChange(null, null)}
          customRanges={dateRanges}
          opens="left"
        />
      </div>
    </div>
  );
}

CareerFilters.propTypes = {
  t: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    user: PropTypes.string,
    userNumber: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
  }).isRequired,
};

export default translate(CareerFilters);
